import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faReceipt, faShoppingCart, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Badge, Button, Container, Image, Nav, Navbar } from "@themesberg/react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { logoutUser } from "../api/auth.api";
import { clearAuthSession, getAuthUser } from "../api/tokenStorage";
import { Routes } from "../routes";
import { getCartCount, subscribeToCartUpdates } from "../utils/cartStorage";
import MiracleWhiteLogo from "../assets/img/MW_Logo.png";

export default () => {
  const history = useHistory();
  const location = useLocation();
  const user = getAuthUser();
  const [cartCount, setCartCount] = useState(getCartCount());

  useEffect(() => {
    const syncCartCount = () => setCartCount(getCartCount());
    return subscribeToCartUpdates(syncCartCount);
  }, []);

  const handleLogout = async () => {
    try {
      console.log("Logging out user:", user?.email);
      await logoutUser();
    } catch (error) {
    } finally {
      clearAuthSession();
      history.push(Routes.Signin.path);
    }
  };

  const isActivePath = (path) => location.pathname === path;

  return (
    <Navbar bg="white" className="shadow-sm border-bottom z-1090 vendor-top-navbar">
      <Container className="d-flex justify-content-between align-items-center px-4 px-lg-3">
        <Navbar.Brand as={Link} to={Routes.Products.path} className="vendor-navbar-brand p-0">
          <Image src={MiracleWhiteLogo} className="vendor-navbar-logo" />
          <span className="fw-bold ms-2 d-none d-lg-inline">Miracle White</span>
        </Navbar.Brand>
        <Nav className="d-none d-lg-flex align-items-center gap-3 order-2">
          <Nav.Link
            as={Link}
            to={Routes.Products.path}
            className={isActivePath(Routes.Products.path) ? "fw-bold text-primary" : ""}
          >
            <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
            Products
          </Nav.Link>
          <Nav.Link
            as={Link}
            to={Routes.MyOrders.path}
            className={isActivePath(Routes.MyOrders.path) ? "fw-bold text-primary" : ""}
          >
            <FontAwesomeIcon icon={faReceipt} className="me-2" />
            My Orders
          </Nav.Link>
          <Nav.Link
            as={Link}
            to={Routes.Cart.path}
            className={isActivePath(Routes.Cart.path) ? "fw-bold text-primary" : ""}
          >
            <FontAwesomeIcon icon={faShoppingCart} className="me-2" />
            Cart
            {cartCount > 0 ? <Badge bg="primary" pill className="ms-2">{cartCount}</Badge> : null}
          </Nav.Link>
        </Nav>
        <div className="d-flex align-items-center gap-2 order-1 order-lg-3">
          <span className="text-muted small">{user?.email || "Vendor"}</span>
          <Button variant="outline-danger" size="sm" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span className="d-none d-lg-inline ms-2">Logout</span>
          </Button>
        </div>
      </Container>
    </Navbar>
  );
};